import React from 'react';
import {v4 as uuidv4} from "uuid";
import Button from "../../../Button";

const swapElement = (array, indexA, indexB) => {
    let tmp = array[indexA];
    array[indexA] = array[indexB];
    array[indexB] = tmp;

    return array;
}

const CreateEditLineItems = (props) => {
    const {
        lineItems       = [],
        onChange        = (lineItems) => {},
        disabled        = false,
        errors          = null,
        canAddItems     = true,
        canDeleteItems  = true,
    } = props;

    const handleAddLineItem = () => {
        const clone = _.cloneDeep(lineItems);

        clone.push({
            id:     uuidv4(),
            name:   "",
            detail: "",
            order:  clone.length + 1,
        });

        onChange(clone);
    }

    const handleRemoveLineItem = (item) => {
        const clone = _.cloneDeep(lineItems);

        let index = null;
        for (let i = 0; i < clone.length; i++) {
            if (clone[i].id === item.id) {
                index = i;
            }
        }

        clone.splice(index, 1);

        for (let i = 0; i < clone.length; i++) {
            clone[i].order = i + 1;
        }

        onChange(clone);
    }

    const handleReorder = (index, item, direction) => {
        let clone = _.cloneDeep(lineItems);

        let indexA = index;
        let indexB = index;

        /**
         * Swap the line item order based on the previous position and the reorder direction.
         */
        if (direction === "up") {
            indexB = indexA - 1;
        } else if (direction === "down") {
            indexB = indexA + 1;
        }

        clone = swapElement(clone, indexA, indexB)

        for (let i = 0; i < clone.length; i++) {
            clone[i].order = i + 1;
        }

        onChange(clone);
    }

    const handleUpdate = (item) => {
        const clone = _.cloneDeep(lineItems);

        for (let i = 0; i < clone.length; i++) {
            if (clone[i].id === item.id) {
                clone[i] = item;
                break;
            }
        }

        onChange(clone);
    }

    const renderNoItems = () => {
        return (
            <div className={"line-item-row empty"}>
                <span>No Line Items</span>
            </div>
        )
    }

    const renderLineItemRow = (index, item) => {
        let nameError   = null;
        let detailError = null;

        if (!!errors && !!errors["product_line_items."+index+".name"]) {
            nameError = errors["product_line_items."+index+".name"];
        }

        if (!!errors && !!errors["product_line_items."+index+".detail"]) {
            detailError = errors["product_line_items."+index+".detail"];
        }

        return (
            <div className={"line-item-row"} key={item.id}>
                <div className="column order-column">
                    <div className={"order-controls"}>
                        <div className={parseInt(item.order) === 1 ? "up disabled" : "up"}
                             onClick={() => !disabled ? handleReorder(index, item, "up") : {}}
                        >
                            <i className="fas fa-arrow-alt-up fa-fw" />
                        </div>
                        <div className={parseInt(item.order) === lineItems.length ? "down disabled" : "down"}
                             onClick={() => !disabled ? handleReorder(index, item, "down") : {}}
                        >
                            <i className="fas fa-arrow-alt-down fa-fw" />
                        </div>
                    </div>
                </div>
                <div className="column name-column">
                    <input
                        type="text"
                        className={nameError ? "form-control shadow-none is-invalid" : "form-control shadow-none"}
                        disabled={disabled}
                        value={item.name}
                        onChange={(event) => {
                            const clone = _.cloneDeep(item);
                            clone.name = event.target.value;

                            handleUpdate(clone);
                        }}
                    />
                </div>
                <div className="column detail-column">
                    <input
                        type="text"
                        className={detailError ? "form-control shadow-none is-invalid" : "form-control shadow-none"}
                        disabled={disabled}
                        value={item.detail}
                        onChange={(event) => {
                            const clone = _.cloneDeep(item);
                            clone.detail = event.target.value;

                            handleUpdate(clone);
                        }}
                    />
                </div>
                <div className="column action-column">
                    {(canDeleteItems === true) && (
                        <div className={"archive-button"}
                             onClick={() => !disabled ? handleRemoveLineItem(item) : {}}
                        >
                            <i className="fas fa-minus-circle" />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className={"m-0 mb-4 product-line-items-table"}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                    <div className={"h5 mb-0 text-eh-navy"}>
                        Line Items
                    </div>
                </div>
                <div className={canAddItems ? "line-item-table mb-3" : "line-item-table"}>
                    <div className="header">
                        <div className="column order-column" />
                        <div className="column name-column">
                            <span>Line Item</span>
                        </div>
                        <div className="column detail-column">
                            <span>Quantity</span>
                        </div>
                        <div className="column action-column" />
                    </div>
                    {!!lineItems && lineItems.length > 0 ? lineItems.map((item, index) => renderLineItemRow(index, item)) : renderNoItems()}
                </div>
                {(canAddItems === true) && (
                    <div className={"row m-0 p-0"}>
                        <div className="col-12 m-0 p-0">
                            <Button
                                label={"Add Line Item"}
                                onClick={() => handleAddLineItem()}
                                icon={"far fa-plus-circle"}
                                classes={"btn-eh-lilac px-4 m-0"}
                            />
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default CreateEditLineItems;
